<template>
  <v-container fluid grid-list-xl>

    <v-layout row wrap>

      <v-flex xs12 sm6>
        <img src="/img/intro_login.jpg" class="intro-image">
      </v-flex>

      <v-flex xs12 sm6>
        <LoginCard class="login-register-box"/>
        <SignWithCard class="login-register-box"/>
      </v-flex>

    </v-layout>

    <!-- <p>You don't have an account? You can <router-link to="/register">create one</router-link></p> -->

  </v-container>
</template>

<script>
import SignWithCard from '@/components/auth/SignWithCard.vue';
import LoginCard from '@/components/auth/LoginCard.vue';

export default {
  name: 'Login',
  components: {
    SignWithCard,
    LoginCard
  },
  data() {
    return {
      debug: false
    }
  },
  watch: {
  },
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
</style>